<div class="schema-detail">
  <app-models-table-detail
    *ngIf="selectedTable"
    [schemaId]="schemaId"
    [tableId]="selectedTable.id"
    [tableName]="selectedTable.name"
    (back)="closeTable()">
  </app-models-table-detail>

  <ng-container *ngIf="!selectedTable">
    <div class="schema-detail__header">
      <button mat-button (click)="back.emit()">&larr; Back to Schemas</button>
      <strong class="schema-detail__title">{{ schemaName }}</strong>
    </div>

    <mat-tab-group>
      <mat-tab label="Tables">
        <p class="schema-detail__hint">Right-click a table to manage its fields.</p>
        <wc-grid
          gridKey="modelsTables"
          [context]="gridContext"
          [showQuickSearch]="true"
          [contextMenuItems]="tableRowActions"
          (contextMenuAction)="openTable($event)">
        </wc-grid>
      </mat-tab>

      <mat-tab label="Foreign Keys">
        <div class="schema-detail__toolbar">
          <button mat-flat-button color="primary" (click)="openForeignKeyDialog()">+ Add Foreign Key</button>
        </div>
        <wc-grid #fkGrid gridKey="modelsForeignKeys" [context]="gridContext" [showQuickSearch]="true"></wc-grid>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</div>
